const fuelNumber = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false
});

/** Presentation only. Never use this formatted value as a saved price. */
export function formatFuelAmount(value: unknown): string | null {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && !value.trim()) return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? fuelNumber.format(amount) : null;
}

export function formatFuelPrice(value: unknown): string {
  const amount = formatFuelAmount(value);
  return amount === null ? '--' : `$${amount}`;
}
